module.exports = __webpack_public_path__ + "img/notes.6c7c2497.svg";